import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigation } from "react-router-dom";
import PropTypes from "prop-types";
import { useApplicationLoaderContext } from "../ApplicationLoaderContext";
import posthog from "posthog-js";
PublicLayout.propTypes = {
    children: PropTypes.node
};
export default function PublicLayout(param) {
    var _param_children = param.children, children = _param_children === void 0 ? null : _param_children;
    var setIsPageLoaderShown = useApplicationLoaderContext().setIsPageLoaderShown;
    var navigation = useNavigation();
    var location = useLocation();
    useEffect(function() {
        if (navigation.state === "loading") {
            setIsPageLoaderShown(true);
        } else {
            setIsPageLoaderShown(false);
        }
        return function() {
            return setIsPageLoaderShown(true);
        };
    }, [
        navigation.state
    ]);
    useEffect(function() {
        posthog.capture("$pageview", {
            $current_url: window.location.href
        });
    }, [
        location
    ]);
    return /*#__PURE__*/ React.createElement("main", {
        className: "flex h-full min-h-screen items-start justify-center xl:items-center"
    }, children || /*#__PURE__*/ React.createElement(Outlet, null));
}
